import { Tag, TagProps } from '@chakra-ui/react';
import { UserRole, UserRoleColor } from './user-role.enum';

type UserRoleTagProps = TagProps & {
  role: keyof typeof UserRole
}

export default function UserRoleTag({ role, ...props }: UserRoleTagProps) {
  
  return (
    <Tag 
      colorScheme={UserRoleColor[role]}
      {...props}
    >
      { UserRole[role] }
    </Tag>
  )
}
